import { Skeleton } from '@mui/material';
import Typography from '@mui/material/Typography';
import { CalendarDay } from 'further-ui/utils';
// import DownloadMenu from './DownloadMenu';

type Props = {
  commitmentDate?: CalendarDay;
  closeDate?: CalendarDay;
  commitmentIds?: Array<string>;
  vehicleId?: string;
  isLoading?: boolean;
};

const CustomHeaderActions: React.FC<Props> = ({
  closeDate,
  commitmentDate,
  isLoading,
}) => {
  return isLoading ? (
    <Skeleton variant="text" width={200} />
  ) : (
    <>
      <Typography variant="h6">
        Initial commitment{' '}
        <Typography variant="body2" component="span">
          {commitmentDate?.toReadable()}
        </Typography>
      </Typography>
      {closeDate ? (
        <Typography variant="h6">
          Close{' '}
          <Typography variant="body2" component="span">
            {closeDate?.toReadable()}
          </Typography>
        </Typography>
      ) : null}
      {/* to implement in FUR-3675 */}
      {/* <DownloadMenu commitmentIds={commitmentIds} vehicleId={vehicleId} /> */}
    </>
  );
};

export default CustomHeaderActions;
